import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal, NgbProgressbarConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Res } from 'src/app/models';
import { AuthService, DialogModalService, ValidatorsService } from 'src/app/services';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';
import { ConfirmEmailValidator } from './confirm-email.validator';
import { Subscription } from 'rxjs';
import { verify } from 'crypto';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirm-email',
  templateUrl: './confirm-email.component.html',
  styleUrls: ['./confirm-email.component.css']
})
export class ConfirmEmailComponent implements OnInit {

  subscriptions: Subscription = new Subscription();
  progressRef: NgProgressRef;
  notification: any;
  errorMessages: any;
  email: string;
  checkEmail: object;
  confirmation_code: string;
  isEmailCheck: boolean;

  intervalId = 0;
  seconds = 161;

  @Input() set data(value) {

    if (value != null) {

      this.email = value.email;

    }
  }

  constructor(
    private fb: UntypedFormBuilder,
    public ngProgress: NgProgress,
    private authService: AuthService,
    public activeModal: NgbActiveModal,
    private dialogModal: DialogModalService,
    private validator: ConfirmEmailValidator,
    private validatorService: ValidatorsService,
    private router: Router,
  ) { }

  formConfirm: UntypedFormGroup = this.fb.group({
    confirmation_code: [null, this.validator.confirmation_code],
  })

  ngOnInit(): void {

    this.setData();

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.start();

    this.authService.listenerIsEmailCheck().subscribe(value => {

      if (value) {

        this.activeModal.close(this.confirmation_code);

        this.router.navigate(['login']);
      }
    });

    this.subscriptions.add(

      this.formConfirm.get('confirmation_code').valueChanges.subscribe(val => {

        this.confirmation_code = val;
      })
    );

    this.authService.checkEmail(this.checkEmail, this.progressRef);

    this.errorMessages = this.validator.errorMessages;


  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
  * 
  */
  checkRegistration() {

    let params = {
      email: this.email,
      code: this.confirmation_code,
      action: 'regestration'
    }

    return this.authService.checkRegistrationCode(params);

  }

  /**
  * 
  */
  start() {

    this.countDown();
  }

  /**
  * 
  */
  countDown() {
    this.clearTimer();
    this.intervalId = window.setInterval(() => {
      this.seconds -= 1;
      if (this.seconds === 0) {
      }
      else {
        if (this.seconds < 0) { this.seconds = 0; }
      }
    }, 1000);
  }

  /**
   * 
   */
  clearTimer() {

    clearInterval(this.intervalId);

  }


  /**
   * 
   */
  setData(): void {

    this.checkEmail = {
      email: this.email,
      action: 'regestration'
    }
  }


  /**
 * 
 * @param field 
 * @param type 
 */
  validation(field: string, type: string): boolean {

    return this.validatorService.validation(this.formConfirm.get(field), type);
  }

  /**
   * 
   * @param field 
   */
  checkingFieldStatus(field: string): string {

    return this.validatorService.checkingFieldStatus(this.formConfirm.get(field));
  }

}
